// @flow

/**
 * @deprecated
 *
 * All canonical URLs and their routes should come from graphql and Url Service. You
 * should not need this module for building or parsing canonical URLs and it won't work
 * in most cases. There is legacy support for building canonical URL for social pages but they
 * will be removed in the future. Reach out to web platform and SEO if you think you have a
 * need to use this module.
 *
 * It is ok to use this for non canonical URLs. e.g. /Hotels?g=60745
 * Non canonical URL will be redirected and therefore should be avoided if the URL is used for SEO purpose, or if you
 * care about the cost of round tripping your users to the frontends an additional time.
 *
 * Temporary stub implementation of URL canonicalization. This will eventually
 * be replaced with API calls to a service.
 */

import type { Route } from './types';
import { build, parse } from './pages';

// This is terrible, but it's just a short-term hack.
// This regex requires a path and optionally supports a query param.
const URL_REGEX = /^\/([^?]+)(?:\?(.*))?$/;

const TOURISM_REGEX = /Tourism-g(\d+)/g;

/**
 * This is not functional.  Stop.  Get your URLs from GraphQL or other server APIs.
 *
 * @deprecated
 */
const buildUrl = ({ page: servlet, ...rest }: Route) => {
  const { path, ...params } = (build[servlet] || build.default)(servlet, rest);
  let realPath = path;
  if (
    params.nonEmptyPathParams &&
    params.nonEmptyPathParams.length &&
    params.nonEmptyPathParams[0].match(TOURISM_REGEX)
  ) {
    realPath = params.nonEmptyPathParams.shift();
    // If this array now empty, make it undefined so it isn't picked up later and added as an empty parameter to the url
    if (!params.nonEmptyPathParams.length) {
      params.nonEmptyPathParams = undefined;
    }
  }

  // Our URLSearchParams polyfill doesn't accept values that are undefined.
  const paramsWithoutUndefined = Object.keys(params)
    .filter(key => params[key] !== undefined)
    .reduce((acc, key) => {
      acc[key] = params[key];
      return acc;
    }, {});

  const queryParams = new URLSearchParams(paramsWithoutUndefined).toString();
  return `/${realPath}${queryParams.length ? '?' : ''}${queryParams}`;
};

/**
 * This is not functional.  Stop.  Get your URLs from GraphQL or other server APIs.
 *
 * @deprecated
 */
const parseUrl = (relativePath: string): ?Route => {
  let route;
  let page: string;
  const [, path, query] = URL_REGEX.exec(relativePath) || [null, '', ''];
  const [...params] = path.split('/');

  const tourismMatches = relativePath.match(TOURISM_REGEX);

  // special case for home which doesn't have a servlet path
  if (relativePath === '/') {
    page = 'Home';
  } else if (tourismMatches && tourismMatches.length > 0) {
    // special case for Tourism-g# which the react routes are set up to use Home-g#
    page = tourismMatches[0].replace('Tourism', 'Home');
  } else {
    if (!path) {
      return null;
    }
    page = params.shift();
  }

  const pageParser = parse[page];
  // use matched SPA route parser for params if any
  if (pageParser) {
    route = { page, ...pageParser(...params) };
  }
  // otherwise we can assume it is a non SPA route and pass the context to the default parser
  else {
    route = { ...parse.default(page, ...params) };
  }

  new URLSearchParams(query).forEach((value, key) => {
    route[key] = value;
  });
  return route;
};

export { buildUrl, parseUrl };
